module.exports = __webpack_public_path__ + "img/scene-parking.738f00b1.jpg";